import { extendServiceContainer } from '@iotize/tap';
import { FileSystemService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    fileSystem: FileSystemService;
  }
}

export const _TAP_SERVICE_EXTENSION_FILESYSTEM_ = extendServiceContainer(
  'fileSystem',
  FileSystemService,
);
